<template>
  <div class="card card-carousel overflow-hidden h-100 p-0">
    <div id="carouselExampleCaptions" class="carousel slide h-100" data-bs-ride="carousel">
      <div class="carousel-inner border-radius-lg h-100">
        <!-- <div
          class="carousel-item h-100 active"
          style="background:linear-gradient(0deg, rgba(9, 0, 51, 0.3), rgba(9, 0, 51, 0.822)),url(https://dicora.com/wp-content/uploads/2022/06/eeee.jpg); background-size: cover"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <h5 class="text-white mb-1">DICORA</h5>
            <p>PROVEEDOR AUTORIZADO EN SUPER MORA COSTA RICA</p>
          </div>
        </div> -->
        <div
          class="carousel-item h-100 active"
          style="background:linear-gradient(0deg, rgba(9, 0, 51, 0.3), rgba(9, 0, 51, 0.822)),url(https://dicora.com/wp-content/uploads/2022/07/inn-scaled.jpg); background-size: cover"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <h5 class="text-white mb-1">INNOVACIÓN EN MEDIOS</h5>
            <p>PRODUCTOS EN FRÍO.</p>
          </div>
        </div>
        <div
          class="carousel-item h-100"
          style="background:linear-gradient(0deg, rgba(9, 0, 51, 0.3), rgba(9, 0, 51, 0.822)),url(https://dicora.com/wp-content/uploads/2021/12/Televisores-scaled.jpg); background-size: cover"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            <h5 class="text-white mb-1">CIRCUITOS DIGITALES</h5>
            <p>ESPECIALES</p>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev w-5 me-3"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next w-5 me-3"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "carousel",
};
</script>
